import styled from "styled-components";
import { animationDuration, zIndex } from "../../../NavigationBar/theme";

export const StyledWrapper = styled.div`
  width: 100%;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 0;
  z-index: ${zIndex.bottomLayer};
  transition: grid-template-columns ${animationDuration.fast}ms ease-in-out;

  &.enter-active {
    grid-template-columns: 1fr 0;
  }

  &.enter-done {
    grid-template-columns: 1fr 53px;
  }

  &.exit-active {
    grid-template-columns: 1fr 0;
  }
`;

export const StyledSearchIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 10px;
  width: 16px;
  height: 16px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    width: 100%;
    height: auto;
  }
`;

export const StyledButton = styled.button`
  color: #000;
  margin-left: 8px;
  padding: 0;
  opacity: 0;
  cursor: pointer;
  transition: opacity ${animationDuration.fast}ms ease-in-out;

  &.enter-active {
    opacity: 0;
  }

  &.enter-done {
    opacity: 1;
  }

  &.exit-active {
    opacity: 0;
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #ababab;
  border-radius: 8px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 36px;
  color: #000;
  padding: 0 10px 0 36px;

  &:focus {
    border: 1px solid #3aa6e8;
    box-shadow: 0 0 0 2px rgb(58 166 232 / 50%);
    outline: none;
  }

  &::placeholder {
    color: #9e9e9e;
  }
`;
